export interface WorkEntry {
  title: string;
  location: string;
  dates: string;
  description: string;
  tools: string;
  image?: string;
  details?: string[];
}

export const content = {
  name: "Colin Kuzmick",

  welcome:
    "I'm an undergraduate in Computer Science at the University of Virginia with minors in Electrical Engineering and Japanese Language.",

  work: [
    {
      title: "Full-Stack Marketplace Web App",
      location: "Charlottesville, VA",
      dates: "August 2025 - December 2025",
      description:
        "Built a full-stack marketplace style web application using Django-python, where users can list and claim old/unwanted items to promote sustainability at the University of Virginia.",
      tools: "Django, Python, HTML, AWS Amazon S3, Google Login API.",
      image: "/assets/screenshot.png",
      details: [
        "Listing, Claiming, Messaging, Uploading Images, Login, Profile Editing, Content Moderation.",
        "Facilitated cross-team communication to ensure subsystem compatibility across sprint deadlines. Led development for administration features, requiring deep understanding of all web application sub features.",
      ],
    },
    {
      title: "Connect Four AI",
      location: "Laurel Ridge Community College, Middletown, VA",
      dates: "March 2022 - May 2022",
      description:
        "Programmed a Connect Four game in Java with a rule-based AI opponent that evaluates board positions to block player winning moves.",
      tools: "Java",
      image: "/assets/connect-four.png",
    },
    {
      title: "NAND to High Level Language",
      location: "Laurel Ridge Community College, Middletown, VA",
      dates: "January 2023 - May 2023",
      description:
        "Emulated creation of a working CPU, starting from NAND chips and implementing various levels of abstraction to translate CPU instructions into higher level language programs.",
      tools: "Assembly, Python",
    },
  ] satisfies WorkEntry[],

  images: {
    restaurant: "/assets/restaurant.jpg",
  },

  resume: "/assets/resume.pdf",
};
